import { useContext, useEffect } from "react"
import { NotificationCtx } from "../../context/notificationContext"
import { Button } from "../ui/button"
import { SvgCheckCircle, SvgNotifications } from "../icons/"
import { ListNotifications } from "./ListNotifications"
import styles from "../../pages/dashboard/CoachDashboard/CoachDashboardBento.module.css"

export function NotificationCenter() {
  const { notifications, markAllAsRead, hideNotificationAlert } = useContext(NotificationCtx)

  useEffect(() => {
    hideNotificationAlert()
  }, [])

  return (
    <div className="">
      <div className="flex justify-between items-center gap-2 -mt-[37px]">
        <div className="flex items-center gap-[12px]">
          <h3 className="font-bold text-lg flex flex-row gap-2">
            <SvgNotifications /> My Notifications
          </h3>
        </div>
        <div>
          <Button
            variant="link"
            size="sm"
            onClick={markAllAsRead}
            disabled={!notifications.filter((n) => !n.viewed).length}
          >
            <SvgCheckCircle />
            Mark all as read
          </Button>
        </div>
      </div>

      <div className={`${styles.scrollBar} p-4 overflow-y-auto max-h-[350px]`}>
        <ListNotifications />
      </div>
    </div>
  )
}